import i18n from "i18next";
import type { FC } from "react";

import { SecondaryButton } from "../Buttons/components/ActionButton";

export type GenerateCampaignButtonProps = {
    isDisabled: boolean;
    onClick: () => void;
};

export const GenerateCampaignButton: FC<GenerateCampaignButtonProps> = ({ isDisabled, onClick }) => (
    <SecondaryButton name="generate_form" onClick={onClick} disabled={isDisabled}>
        {i18n.t("campaignEditForm.generateCampaign")}
    </SecondaryButton>
);
